import { faCheck, faCheckCircle } from '@fortawesome/pro-solid-svg-icons'
import { ActionButton, HeadingItem } from 'components'
import { SearchResultList } from 'components/item-verification'
import { TripContext } from 'contexts'
import React, { FC, Fragment, useContext } from 'react'
import { CatchWeight, LicensePlate, LicensePlateItem, Order, OrderItem, OrderItemChange, OrderLicensePlate } from 'services/types'
import { IconOptions } from 'types'
import { SearchResultHelper } from 'utils'
import './lp-details.scss'

type Props = {
    licensePlateId: number | undefined
    onVerify?: () => void
    onDetailsClicked: (orderItem: OrderItem) => void
    onVerifyClicked: (orderItem: OrderItem) => void
}

export const LpDetails: FC<Props> = ({ licensePlateId, onVerify, onDetailsClicked, onVerifyClicked }) => {
    const tripContext = useContext(TripContext)
    const lp: LicensePlate = tripContext.licensePlates.find(lp => lp.id === licensePlateId) ?? {} as LicensePlate
    const orderLps: OrderLicensePlate[] = tripContext.orderLicensePlates.filter(lpo => lpo.licensePlateId == lp.id)
    const lpItems: LicensePlateItem[] = tripContext.licensePlateItems.filter(lpi => lpi.licensePlateId === licensePlateId)
    const lpOrders: Order[] = tripContext.orders.filter(o => orderLps.some(olp => olp.orderId == o.id))
    const orderItems: OrderItem[] = tripContext.orderItems.filter((oi: OrderItem) => lpOrders.some(o => o.id == oi.orderId) && lpItems.some(lpi => lpi.lineItemId == oi.lineItemId))
    const orderItemsChanges: OrderItemChange[] = tripContext.orderItemChanges.filter(change => orderItems.some(orderItem => orderItem.id == change.orderItemId))
    const stopCatchWeights: CatchWeight[] = tripContext.catchWeights.filter(cw => orderItems.some(item => item.id === cw.orderItemId))

    const { notVerifiedItems, shortedItems, changesItems, verifiedItems } = SearchResultHelper.categorizeOrderItems(orderItems ?? [], orderItemsChanges, stopCatchWeights)
    const results = SearchResultHelper.convertOrderItemsToSearchResults(notVerifiedItems, shortedItems, changesItems, verifiedItems, orderItemsChanges)
    let rightHandIconDetails: IconOptions = { icon: faCheckCircle, size: '2x', color: '#76AB21' }

    return (
        <div className={'verify-lp-container'}>
            {lp?.id &&
                <Fragment>
                    <div className={'verify-lp-header-fix'}>
                        <div className={'verify-lp-header-container'}>
                            <HeadingItem text={`LP: ${lp.id.toString()}`} rightHandIcon={lp.verifiedMethod != null ? rightHandIconDetails : undefined} />
                            <div className={'verify-lp-header-details-container'}>
                                <div>Not Verified: {notVerifiedItems.length}</div>
                                <div>Verified: {verifiedItems.length}</div>
                            </div>
                            {!lp.verifiedMethod &&
                                <ActionButton
                                    icon={faCheck}
                                    buttonColor={'#EB5757'}
                                    buttonText='Verify LP'
                                    onClick={onVerify}
                                />
                            }
                        </div>
                        <HeadingItem text={`Items`} />
                    </div>
                    <div className={'lp-details-items-container'}>
                        <SearchResultList
                            results={results.allResults}
                            onDetailsClicked={onDetailsClicked}
                            onVerifyClicked={onVerifyClicked}
                        />
                    </div>
                </Fragment>
            }
        </div>
    )
}